module.exports = __webpack_public_path__ + "media/images/icons/categories-ff50f5b60ede32a116b51b07a9f7323d.gif";